export default {
  '@type': 'MerchantReturnPolicy',
  'applicableCountry': 'SE',
  'merchantReturnLink': 'https://www.timberland.se/en-se/customer-care/returns',
  'returnPolicyCategory': 'https://schema.org/MerchantReturnFiniteReturnWindow',
  'returnMethod': 'https://schema.org/ReturnByMail',
  'merchantReturnDays': 30
}
